class NotificationMock {}

export default window.Notification || NotificationMock
